module.exports = __webpack_public_path__ + "cf6ada996c4f8f237ffeb20d98ca03e0.png";